import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="flex flex-col items-center justify-center h-64 text-center px-4">
          <div className="text-4xl mb-4">😵</div>
          <h2 className="text-xl font-semibold text-gold-300 mb-2">
            Oups, quelque chose s'est mal passé
          </h2>
          <p className="text-dark-300 mb-4">
            {this.state.error?.message || 'Une erreur inattendue est survenue.'}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-gold-500 text-dark-900 rounded-lg font-medium hover:bg-gold-400 transition-colors"
          >
            Recharger la page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
